<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-btn v-if="!roles.isBidder()" @click="exportData" color="primary" dark class="mb-4 ml-3">Eksportuj</v-btn>
		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr :class="props.item.offerCreationTermExpired ? 'termExpired' : ''" :key="props.item.id">
					<td style="width: 70px;">
						<v-tooltip bottom v-if="props.item.offerCreationTermExpired">
							<template v-slot:activator="{ on }">
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>Upłynął termin składania ofert</span>
							<span v-if="props.item.contestStatus === 'FINISHED'">; Konkurs zakończony</span>
						</v-tooltip>
					</td>
					<td>{{ props.item.name }}</td>
					<td>{{ props.item.endDate }}</td>
					<td>{{ props.item.departmentName }}</td>
					<td>
						<PublicContestDataTableIcon @action="showContestPanel(props.item)" icon="build" name="Panel konkursu"
							v-if="isAdminOrSecretary(props.item)"/>
						<PublicContestDataTableIcon @action="placeAnOffer(props.item)" icon="mail" :name="getSendIconHint(props.item)" :icon-class="getSendIconColor(props.item)"
							v-if="canCreateOffer(props.item)"/>
						<PublicContestDataTableIcon @action="viewForm(props.item)" icon="search" name="Podgląd formularza"
							v-if="roles.isBidder() || roles.isSubBidder() || isAdminOrSecretaryOrLeader(props.item) || isFinishedAndDepartmentWorker(props.item)"/>
						<PublicContestDataTableIcon @action="browseSerialWritings(props.item)" icon="grading" name="Pisma seryjne"
							v-if="(props.item.contestStatus !== 'NEW') && (isAdminOrSecretary(props.item) || isFinishedAndDepartmentWorker(props.item))"/>
						<PublicContestDataTableIcon @action="evaluateBidders(props.item)" icon="assessment" name="Ocena współpracy"
							v-if="props.item.committeeEvaluationFormDefined && !['NEW', 'ANNOUNCED'].includes(props.item.contestStatus) && (isAdminOrSecretaryOrLeader(props.item) || isFinishedAndDepartmentWorker(props.item))"/>
						<PublicContestDataTableIcon @action="browseOffers(props.item)" icon="mail" name="Ocena ofert"
							v-if="showBrowseOfferButton(props.item)"/>
						<PublicContestDataTableIcon @action="committeesEvaluationSummary(props.item)" icon="event_seat" name="Zbiorcza ocena w komisjach"
							v-if="!(['NEW', 'ANNOUNCED'].includes(props.item.contestStatus)) && (isAdminOrSecretaryOrLeader(props.item) || isFinishedAndDepartmentWorker(props.item))"/>
						<PublicContestDataTableIcon @action="rankingList(props.item)" icon="calendar_today" name="Lista rankingowa"
							v-if="!(['NEW', 'ANNOUNCED'].includes(props.item.contestStatus)) && (isAdminOrSecretaryOrLeader(props.item) || isFinishedAndDepartmentWorker(props.item))"/>
						<PublicContestDataTableIcon @action="finalProtocol(props.item)" icon="assignment_turned_in" name="Protokół końcowy"
							v-if="(isAdminOrSecretary(props.item) || isFinishedAndDepartmentWorker(props.item)) && props.item.allOffersEvaluationFinished === true"/>
						<PublicContestDataTableIcon @action="contestSummary(props.item)" icon="ballot" name="Podsumowanie konkursu"
							v-if="(isAdminOrSecretaryOrLeader(props.item) || isFinishedAndDepartmentWorker(props.item)) && 'FINISHED' === props.item.contestStatus"/>
						<PublicContestDataTableIcon @action="browseProjects(props.item)" icon="business" name="Projekty"
							v-if="['FINAL_EVALUATION', 'FINISHED'].includes(props.item.contestStatus) && (isAdminOrSecretary(props.item) || isFinishedAndDepartmentWorker(props.item))"/>
						<PublicContestDataTableIcon @action="viewFiles(props.item)" icon="folder" name="Dokumenty konkursowe"
							v-if="canCreateOffer(props.item)"/>	
						<PublicContestDataTableIcon @action="deleteContest(props.item)" icon="delete" name="Usuń konkurs" icon-color="lightred"
							v-if="isAdminOrSecretary(props.item) && 'NEW' === props.item.contestStatus"/>
					</td>
				</tr>
			</template>
		</v-data-table>

		<v-dialog v-model="noBrowseOffersAccess" width="500">
			<v-card>
				<v-card-title class="headline blue white--text">
					Brak dostępu
				</v-card-title>
				<v-card-text>
					Konkurs nie jest jeszcze zakończony. Aby przeglądać oferty, powinieneś posiadać rolę w danym
					konkursie.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="noBrowseOffersAccess = false">Zamknij</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {Bidder} from "@/api/generated/Bidder";
	import {role} from "@/utils/Role";
  import PublicContestDataTableIcon from "@/view/logged/contest/components/PublicContestDataTableIcon";

	export default {
		name: "PublicContestDataTable",
    components: {PublicContestDataTableIcon},
    methods: {
			exportData() {
				let endpointMainPath = "public-contest";
				let sort = this.buildSort();
				let path = "/" + endpointMainPath + "/export?search=" + this.dataTable.search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this, "/public-contest/list?search=" + this.dataTable.search
					+ "&page=" + this.dataTable.pagination.page
					+ "&result=" + this.dataTable.pagination.rowsPerPage
					+ "&sort=".concat(sort), response => {
					this.dataTable.itemList = response.itemList;
					this.dataTable.itemCount = response.itemCount;
				});
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			deleteContest (contest) {
				this.$confirm("Czy na pewno chcesz usunąć konkurs?", {
					icon: 'delete',
					title: 'Uwaga',
					color: "lightred",
					width: 500
				}).then(response => {
					if (response) {
						PublicContest.delete(this, contest.id, () => {
							this.getItemList();
						}, () => {
							this.$messagesBus.$emit("error", "Nie udało się usunąć konkursu");
						});
					}
				});
			},

			async noAccessToBrowseOffers (contest) {
				let contestRole;
				if (!this.roles.isDepartmentEmployee() || contest.contestStatus === "FINISHED") return false;
				await Api.syncGet(this, "/public-contest/contest-role?contestId=".concat(contest.id), successResponse => {
						contestRole = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać roli w konkursie", errorResponse);
					});
				return !contestRole || contestRole === "NONE";
			},

			showContestPanel (contest) {
				this.$router.push("/app/contest/" + contest.id + "/panel/main-data");
			},

			rankingList (contest) {
				this.$router.push("/app/contest/" + contest.id + "/final-ranking");
			},

			finalProtocol(contest) {
				this.$router.push("/app/contest/" + contest.id + "/final-protocol");
			},

			viewFiles (contest) {
				this.$router.push("/app/contest/" + contest.id + "/view-files");
			},

      viewForm(contest) {
        this.$router.openInNewTab("/empty-offer/" + contest.id);
      },

			placeAnOffer (contest) {
				this.$router.push("/app/contest/" + contest.id + "/my-offer-list");
			},

			async browseOffers(contest) {
				if (await this.noAccessToBrowseOffers(contest)) {
					this.noBrowseOffersAccess = true;
				} else {
					this.$router.push("/app/contest/" + contest.id + "/offer-list");
				}
			},

			browseSerialWritings (contest) {
				this.$router.push("/app/contest/" + contest.id + "/serial-writings");
			},

      canCreateOffer(item) {
        return (this.roles.isBidder() || this.roles.isSubBidder()) && this.isUserLegalFormAllowed(item) && item.bidderAllowedToCreateOffer;
      },

			isAdminOrSecretary (item) {
				return this.roles.isAdministrator() || (this.roles.isLocalAdministrator() && item.contestFromUserDepartment) || item.secretary;
			},

			isAdminOrSecretaryOrLeader(item) {
				return this.roles.isAdministrator() || (this.roles.isLocalAdministrator() && item.contestFromUserDepartment) || item.secretary || item.leader;
			},

			showBrowseOfferButton(item) {
				return item.contestStatus !== 'NEW' && (this.isAdminOrSecretaryOrLeader(item) || this.isFinishedAndDepartmentWorker(item));
			},

			isFinishedAndDepartmentWorker(item) {
				return item.contestFromUserDepartment && item.contestStatus === 'FINISHED' && this.roles.isDepartmentEmployee();
			},

			isCommitteeUser (item) {
				return item.contestStatus !== 'FINISHED' && item.committeeUser;
			},

			browseProjects(contest) {
				this.$router.push("/app/contest/" + contest.id + "/project-list");
			},

			manageCommittees (contest) {
				this.$router.push("/app/contest/" + contest.id + "/manage-committees");
			},

			committeesEvaluationSummary (contest) {
				this.$router.push("/app/contest/" + contest.id + "/committees");
			},

			evaluateBidders (contest) {
				this.$router.push("/app/contest/" + contest.id + "/bidders-evaluation");
			},

			contestSummary (contest) {
				this.$router.push("/app/contest/" + contest.id + "/summary");
			},

			getSendIconColor(contest) {
				if (!this.isUserLegalFormAllowed(contest)) {
					return 'red-icon';
				} else if (contest.offerCreationTermExpired === true) {
					return 'yellow-icon';
				}
				return 'green-icon';
			},

			getSendIconHint(contest) {
				if (!this.isUserLegalFormAllowed(contest)) {
					return null;
				} else if (contest.offerCreationTermExpired === true) {
					return 'Lista ofert';
				}
				return 'Złóż ofertę';
			},

			isUserLegalFormAllowed(contest) {
				return contest.allowedLegalForms.includes(this.userLegalForm);
			},

			getBidderLegalForm() {
				if (role.isBidder() || role.isSubBidder()) {
					Bidder.getBidderLegalForm(this,
						response => {
							this.userLegalForm = response;
						}
					);
				}
			}
		},

		created() {
			this.getBidderLegalForm();
		},

		data () {
			return {
				noBrowseOffersAccess: false,
				dataTable: this.value,
				userLegalForm: ''
			};
		},

		props: {
			value: Object,
		},

		watch: {

			"dataTable.pagination": {
				handler() {
					this.getItemList();
				},
				deep: true
			},
			form: {
				handler () {
					this.$emit("input", this.dataTable);
				}
				,
				deep: true,
			},
		},
	};
</script>

<style scoped>
	.termExpired {
		background-color: rgb(232, 232, 232);
	}

	.theme--dark .termExpired {
		background-color: #606060 !important;
	}
</style>
